import { fetchApi } from '@src/workflows/vs-standard-form/helpers/form.helper';
import { getHeader } from '@src/workflows/vs-standard-form/vs-standard-form.constant';

export const getQuestions = (baseUrl, token, xDataCenter, data) => {
  const  url = baseUrl + '/mepa-api/app/v1/quiz/data';
  return fetchApi(url, getHeader(xDataCenter, data, token, false));
}

export const postStartQuiz = (baseUrl, token, xDataCenter, data) => {
  const  url = baseUrl+'/mepa-api/app/v1/quiz/start';
  return fetchApi(url, getHeader(xDataCenter, data, token, false));
}


export const postFinishQuiz = (baseUrl, token, xDataCenter, data) => {
  const url = baseUrl+'/mepa-api/app/v1/quiz/finish';
  return fetchApi(url, getHeader(xDataCenter, data, token, false));
}


export const getQuizResult = (baseUrl, token, xDataCenter, data) => {
  const url = baseUrl+'/mepa-api/app/v1/quiz/result';
  return fetchApi(url, getHeader(xDataCenter, data, token, false));
}
